import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../../autentication/Auth';
import { PixLimitsReturn } from '../../models/limits-return.model';
import { PixLimitsService } from '../limits.service';

@Component({
	selector: 'app-modal-reduced-limit',
	templateUrl: './modal-reduced-limit.component.html',
	styleUrls: ['./modal-reduced-limit.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixModalReducedLimitComponent implements OnInit {

	public limitValue = 0;
	public selectedLimit: PixLimitsReturn;
	public isTransactionUser = false;

	constructor(
		private router: Router,
		public pixLimitsService: PixLimitsService,
		public dialogRef: MatDialogRef<PixModalReducedLimitComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.selectedLimit = data.selectedLimit;
	}

	ngOnInit(): void {
		this.limitValue = this.selectedLimit.valor;
		this.setIsTransactionUser();
	}

	onClose(): void {
		this.dialogRef.close();
	}

	public onConfirm(): void {
		this.dialogRef.close(true);
	}

	public adjustLimit() {
		this.pixLimitsService.setSelectedLimit(this.selectedLimit);
		this.router.navigate(['pix/limites/ajustar']);
		this.dialogRef.close(true);
	}

	private setIsTransactionUser() {
		this.isTransactionUser = Auth.getInstance().getUser().rule === 'TRANSACIONAR';
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/limits/modal-reduced-limit/modal-reduced-limit.component.ts